import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Custom hook to fetch chat ID by phone number
 */
export function useDeliveryChat(recipientPhone) {
  const [chatId, setChatId] = useState(null);

  useEffect(() => {
    if (!recipientPhone) return;

    let cancelled = false;

    const fetchChatId = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/chat/id_by_phone`,
          {
            params: { phone: recipientPhone }
          }
        );
        
        if (!cancelled) {
          setChatId(data.chat_id ?? null);
        }
      } catch (error) {
        if (!cancelled) {
          console.error('Error fetching chat ID:', error);
          setChatId(null);
        }
      }
    };

    fetchChatId();

    return () => {
      cancelled = true;
    };
  }, [recipientPhone]);

  return chatId;
}